/* ============================================================
   GOOTER - Sticky Mobile Add-to-Cart
   Zeigt die feste Kaufleiste am unteren Bildrand auf Mobile, sobald der
   Hauptbutton NICHT im Sichtfeld ist (06.10.2026: egal ob er oberhalb
   oder noch unterhalb des ersten Bildschirms liegt). Reine Anzeige-Logik;
   der Klick loest weiterhin den echten Hauptbutton aus.
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia('(min-width: 750px)').matches) return;

  var sticky = document.querySelector('.gooter-sticky-add');
  if (!sticky) return;
  var primaryBtn = document.querySelector('product-form button[type="submit"]:not([disabled]), .product-form__submit:not([disabled])');
  if (!primaryBtn) return;

  var stickyBtn = sticky.querySelector('.gooter-sticky-add__btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      primaryBtn.click();
      primaryBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  if (!('IntersectionObserver' in window)) {
    sticky.classList.add('is-visible');
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        sticky.classList.remove('is-visible');
      } else {
        sticky.classList.add('is-visible');
      }
    });
  }, { threshold: 0, rootMargin: '0px' });

  observer.observe(primaryBtn);
})();
